import { NotificationType } from '@vista-digital/occ-domain';
import { Validator } from '@vista-digital/validator';
export const defaultOccSeatingNotificationConfig = {
    show: true,
    style: NotificationType.Warning,
    displayInline: true
};
export const occSeatingNotificationConfigValidator = Validator.object({
    show: Validator.boolean(),
    style: Validator.oneOf(Object.values(NotificationType)),
    displayInline: Validator.boolean()
});
//# sourceMappingURL=notification.js.map